import { render } from "./SaveLoading.vue?vue&type=template&id=0d132624&scoped=true"
import script from "./SaveLoading.vue?vue&type=script&lang=js"
export * from "./SaveLoading.vue?vue&type=script&lang=js"

import "./SaveLoading.vue?vue&type=style&index=0&id=0d132624&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d132624"]])

export default __exports__